export default __webpack_public_path__ + "static/media/profile-with-blob.fb1a81da.svg";